<template>
  <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh" @close="closeDialog">
    <template #title>
      <span>{{`${model.Id > 0 ? "编辑" : "添加"}公开课`}}</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="100px">
        <el-form-item label="课程名称" prop="Name">
          <el-input placeholder="请输入课程名称" :disabled="readonly" v-model="model.Name" class="input-width" />
        </el-form-item>
        <el-form-item label="校区" prop="UniversityGroupNumber">
          <el-select :disabled="readonly" v-model="model.UniversityGroupNumber" placeholder="请选择校区" class="input-width">
            <el-option v-for="item in universityGroups" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="StartTime">
          <el-date-picker align="center" type="datetime" format="yyyy/MM/dd hh:mm A" :disabled="readonly" v-model="model.StartTime" placeholder="请选择开始时间" class="input-width" />
        </el-form-item>
        <el-form-item label="直播间链接" prop="Link">
          <el-input placeholder="请输入直播间链接" :disabled="readonly" v-model="model.Link" class="input-width" />
        </el-form-item>
        <el-form-item label="课程回看地址" prop="VideoPath">
          <el-input placeholder="请输入课程回看地址" :disabled="readonly" v-model="model.VideoPath" class="input-width" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button :disabled="readonly || isSaving" v-loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getUniversityGroups, saveOpenCourse } from "@/service/common.service";

const mixin_generalMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

const defaultData = {
  Id: 0,
  UniversityGroupNumber: null,
  Name: null,
  StartTime: null,
  Link: null,
  VideoPath: null,
};

export default {
  name: "openCourseEditor",
  mixins: [mixin_generalMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "35%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
  },
  data() {
    return {
      isSaving: false,
      dialogVisible: false,
      rules: {
        Name: [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "blur",
          },
          {
            max: 250,
            message: "课程名称不可超过250个字符",
            trigger: "blur",
          }
        ],
        UniversityGroupNumber: [
          {
            required: true,
            message: "请选择校区",
            trigger: "blur",
          },
        ],
        StartTime: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur",
          },
        ],
        Link: [
          {
            required: true,
            message: "请输入直播间链接",
            trigger: "blur",
          },
        ],
      },
      universityGroups: [],
      model: Object.clone(defaultData),
    };
  },
  created() {
    this.dialogVisible = this.visible;
    this.loadUniversityGroupsFromServer();
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async loadUniversityGroupsFromServer() {
      let result = await getUniversityGroups();
      this.universityGroups = !!result && result.success ? result.data : [];
    },
    async saveOpenCourseToServer() {
      this.isSaving = true;
      let data = Object.clone(this.model);
      data.StartTimeText = this.$moment(this.model.StartTime).format("YYYY/MM/DD hh:mm A");

      let result = await saveOpenCourse(data);
      if (!!result && result.success) {
        this.model.Id = result.data;

        this.$message({
          message: "保存成功",
          type: "success"
        });

        this.dialogVisible = false;
        this.$emit("change", this.model);
      }
      this.isSaving = false;
    },

    reloadModelFromDataIn() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(this.data || defaultData);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.saveOpenCourseToServer();
    },
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;

      if (this.visible) this.reloadModelFromDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/openCourse/openCourseEditor.vue